import { render, staticRenderFns } from "./invite_friends.vue?vue&type=template&id=53f32a38&scoped=true"
import script from "./invite_friends.vue?vue&type=script&lang=js"
export * from "./invite_friends.vue?vue&type=script&lang=js"
import style0 from "./invite_friends.vue?vue&type=style&index=0&id=53f32a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f32a38",
  null
  
)

export default component.exports